// Bouwt de aanvraag voor privacyPipelineStream (transcriberen/uitlezen +
// persoonsgegevens weglakken). Sinds 2026-10-13 controleert de server een
// Firebase-inlogsleutel en het lidmaatschap van de organisatie
// (functions/privacy/privacyStreamHandler.js); zonder die twee weigert hij.
// Daarom faalt deze helper zichtbaar als een van beide ontbreekt, in plaats van
// een verzoek te sturen dat als 'Privacy-verwerking kon niet starten' terugkomt.

/**
 * @typedef {object} PrivacyStreamRequest
 * @property {Record<string, string>} headers
 * @property {string} body - JSON
 */

/**
 * @param {object} params
 * @param {'audio' | 'document'} params.mode - Audio in stukken, of één document (pdf/.docx).
 * @param {string[]} params.urls - Download-adressen in de opslag.
 * @param {string} [params.language] - Taalcode voor transcriptie; standaard 'nl'.
 * @param {string} params.compagnyId - De organisatie waarin de gebruiker werkt.
 * @param {string} params.idToken - Firebase-inlogsleutel van de huidige gebruiker.
 * @returns {PrivacyStreamRequest}
 */
const buildPrivacyStreamRequest = ({ mode, urls, language, compagnyId, idToken }) => {
    if (!idToken) throw new Error("Je bent niet (meer) ingelogd. Log opnieuw in en probeer het nog eens.");
    if (!compagnyId) throw new Error("Geen organisatie gevonden voor deze verwerking.");

    const input = mode === "document"
        ? { documentURL: urls[0] }
        : { audioURLs: urls, language: language || "nl" };

    return {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`,
        },
        body: JSON.stringify({ compagnyId, ...input }),
    };
};

export default buildPrivacyStreamRequest;
